import React, { useState, useEffect } from "react";
import Wrapper from "./messagingBanner.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import DOMPurify from 'dompurify';

export const MessagingBanner = ({ bannerMessagingData }) => {
  const {
    messageCloseable,
    messageName,
    showOnce,
    messageTitle,
    messagingContentPrimary,
    messagingContentSecondary,
  } = bannerMessagingData;
  const [showBanner, setShowBanner] = useState(true);
  const [bannerExists, setBannerExists] = useState(true);
  const closeable = messageCloseable;

  const handleClose = () => {
    setShowBanner(false);
    if (showOnce) {
      localStorage.setItem(messageName, "closed");
    }
  };

  useEffect(() => {
    if (showOnce) {
      if (localStorage.getItem(messageName) === "closed") {
        setBannerExists(false);
      }
    }
  }, [messageName, showOnce]);

  return (
    <Wrapper
      $bannerexists={bannerExists}
      $showbanner={showBanner}
      $closeable={closeable}
    >
      {closeable && <div className="empty-div"></div>}
      <div className="messages-group">
        {messageTitle && (
          <div className="message-content-title">{messageTitle}</div>
        )}
        <div
          className="message-content"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(messagingContentPrimary),
          }}
        />
        {messagingContentSecondary && (
          <div
            className="message-content-secondary"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(messagingContentSecondary),
            }}
          />
        )}
      </div>
      {closeable && (
        <div className="close-button" onClick={handleClose}>
          <FontAwesomeIcon className="close-button-lock" color="fff" icon={faTimesCircle} />
        </div>
      )}
    </Wrapper>
  );
};
